import { render, staticRenderFns } from "./ClubCard.vue?vue&type=template&id=0ffdf15a&"
import script from "./ClubCard.controller.js?vue&type=script&lang=js&"
export * from "./ClubCard.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ClubCard.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "19f2d734"
  
)

export default component.exports